<template>
    <div class="cart-component text-none pa-6">
      <div v-if="loading">
				<v-progress-circular
					indeterminate
					color="primary"
					class="progress"
				></v-progress-circular>
      </div>
      <div v-else>
        <div>
          <div
            class="first_row text-left"
            v-if="Object.keys(cart.items).length"
          >
            <label class="container input-label text-left pr-2 mt-2 mb-6 mb-md-0">
              {{check_all ? $t('cart.uncheck_all_label') : $t('cart.check_all_label')}}
              <input type="checkbox" v-model="check_all">
              <span class="checkmark"></span>
            </label>
          </div>
          <div v-if="Object.keys(cart.items).length">
            <div
              v-for="item in Object.keys(cart.items)"
              :key="item"
              :class="{'disabled' : !cart.items[item].is_available}"
              class="row py-8 d-flex flex-md-row flex-column"
            >
              <div class="d-flex">
                <label class="container input-label text-left pr-2 mt-2 mb-6 mb-md-0">
                  <input type="checkbox" v-model="cart.items[item].checked" :id="item" :disabled="!cart.items[item].is_available">
                  <span class="checkmark"></span>
                </label>
                <div class="text-left pr-md-12 pr-0 mb-6 mb-md-0">
                  <div class="reservation_header">{{ cart.items[item].name }}</div>
                  <div class="reservation_id mt-2">
                    <span class="id">{{ $t('cart.donor_nickname_label') }}</span> 
                    <div class="data ml-2">
                      {{cart.items[item]._source.donor_process.donor_nickname}}
                    </div>
                  </div>
                </div>
              </div>
              <v-spacer></v-spacer>
              <div class="text-left pr-md-12 pr-0 mb-6 mb-md-0 pl-md-0 pl-8 d-flex flex-row justify-space-between align-center">
                <div>
                  <div class="reservation_data_label mb-md-0 mb-1">{{ $t('cart.quantity_label') }}</div>
                  <v-text-field 
                    v-model="cart.items[item].quantity"
                    class="d-flex align-center set-quantity"
                    type="number"
                    min="0"
                    :max="maxQuantity(cart.items[item])"
                    :disabled="loading"
                    label=""
                    variant="plain"
                    density="compact"
                    hide-details="auto"
                    readonly
                  >
                    <template v-slot:prepend>
                      <v-btn
                        icon
                        variant="plain"
                        size="default"
                        :class="cart.items[item].quantity <= 1 ? 'set-disabled' : ''"
                        :disabled="cart.items[item].quantity <= 1 ? true : false"
                        @click="removeItem(item)"
                      >
                        <v-icon color="primary" size="24">mdi-minus</v-icon>
                      </v-btn>
                    </template>
                    <template v-slot:append>
                      <v-btn
                        icon
                        variant="plain"
                        size="default"
                        :class="cart.items[item].quantity >= maxQuantity(cart.items[item]) ? 'set-disabled' : ''"
                        :disabled="cart.items[item].quantity >= maxQuantity(cart.items[item]) ? true : false"
                        @click="addItem(item)"
                      >
                        <v-icon color="primary" size="24">mdi-plus</v-icon>
                      </v-btn>
                    </template>

                  </v-text-field>
                </div>
                <div v-if="$vuetify.display.mobile" class="text-left d-flex flex-column justify-center mt-4">
                  <v-icon color="primary" size="22px" @click="deleteElement(item)">mdi-trash-can-outline</v-icon>
                </div>
              </div>
              <div class="text-md-right text-left pr-12 mb-6 mb-md-0 pl-md-0 pl-8 value">
                <div class="reservation_data_label mb-md-0 mb-1">{{ $t('cart.value_label') }}</div>
                <div class="d-flex flex-md-column flex-row flex-wrap">
                  <div :class="['reservation_data_unit_price', cart.items[item].mz_grant_file_id ? 'no-refund' : '']">
                    {{$n(cart.items[item].unit_price * cart.items[item].quantity, 'currency', 'pl')}}
                  </div>
                  <div v-if="cart.items[item].mz_grant_file_id" class="reservation_data_unit_price ml-md-0 ml-2">
                    {{$n(cart.items[item].unit_price * (cart.items[item].quantity - 1), 'currency', 'pl')}}
                  </div>
                  <div class="reservation_data_price ml-0">
                    ({{$n(cart.items[item].unit_price, 'currency', 'pl')}} {{ $t('cart.price_for_package_label') }})
                  </div>

                  <div 
                    v-if="cart.items[item].mz_grant_file_id"
                    :class="['mz-package-label px-1 py-1 mt-2 d-flex', {'mt-6': $vuetify.display.mobile, 'f-right': !$vuetify.display.mobile}]">
                    <img :src="paidIcon" class="mr-1"/> {{ $t('mz.one_refund_package_label') }}
                  </div>
                </div>
              </div>

              <div v-if="!$vuetify.display.mobile" class="text-left d-flex flex-column justify-center align-end">
                <v-icon color="primary" size="22px" @click="deleteElement(item)">mdi-trash-can-outline</v-icon>
              </div>
            </div>
          </div>
          <div v-else class="info">
            <label class="container input-label">{{ $t('cart.no_selected_packages_info') }}</label>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { computed } from 'vue';
import axios from "axios";

export default {
  name: "cart-component",
  data: () => {
    return {
      cart: {
        items: {}
      },
      loading: false,
      check_all: true,
      prices: null,
    }
  },
  computed: {
    ...mapGetters('cartModule', ['getConfig'])
  },
  watch: {
    check_all(n){
      if(n) {
        Object.keys(this.cart.items).forEach(e => this.cart.items[e].checked = true && this.cart.items[e].is_available);
      }
      else {
        Object.keys(this.cart.items).forEach(e => this.cart.items[e].checked = false);
      }
      this.$emit('price-change', {
        value: this.getCartValue(),
        cart_size: this.getCartSize(),
        discount_items: this.getCartSelectedDiscountItems()
      });
    },
    'cart.items': {
      handler() {
        this.$emit('price-change', {
          value: this.getCartValue(),
          cart_size: this.getCartSize(),
          discount_items: this.getCartSelectedDiscountItems()
        });
        let checked = Object.keys(this.cart.items)
          .map(item => {return {...this.cart.items[item], id: item}})
          .filter(item => item.checked == true)
          .map(item => item.id);
        this.$store.dispatch('reservationModule/setChecked', checked);
      },
      deep: true,
    }
  },
  setup() {
    const paidIcon = computed({
      get: () => { return require('@/assets/icons/paid.svg');}
    })

    return {
      paidIcon
    }
  },
  mounted() {
    this.loading = true;
    this.getMaterialPrices().then(() => {
      this.getCart();
    })
    this.$store.dispatch('breadcrumbModule/setRoute', [{
        name: 'breadcrumb.want_to_be_a_parent',
        url: `https://bank.invicta.pl${ this.$t('bank_invicta_path.planning_parenthood') }`,
        absolute: true
      },
      {
        name: 'breadcrumb.reservation_labels.summary',
        url: ''
      }
    ])
  },
  methods: {
    productName(material) {
      let name = ''
      if(material.type == 'mtCell') {
        name = this.$t('reservation.mtCell.product_name', {size: material.package_size})
      } else {
        name = `${this.$t('reservation.mtSemen.product_name')} ${this.$t(material.fitness_for_insemination)}`
      }
      return name;
    },

    maxQuantity(material) {
      let maxTrueReservationCount = material.fields.max_true_reservation_count[0];

      if (maxTrueReservationCount < 0) {
        return 0;
      }

      if (material.material_type == 'mtCell') {
        return maxTrueReservationCount > this.getConfig.material_quantity_cell_limit ? this.getConfig.material_quantity_cell_limit : maxTrueReservationCount;
      } else {
        return maxTrueReservationCount > this.getConfig.material_quantity_semen_limit ? this.getConfig.material_quantity_semen_limit : maxTrueReservationCount;
      }
    },

    getMaterialPrices() {
      return new Promise((resolve, reject) => {
        axios
        .get(`/api/donor/material_price`)
        .then((response) => {
          this.prices = response.data;
          resolve();
        })
        .catch(err => {
          console.error(err);
          reject();
        })
      })
    },
    getCart() {
      return new Promise((resolve, reject) => {
        axios.get('/api/cart')
        .then((response) => {
          this.full_price = 0;
          this.cart = response.data;
          let update = [];
          
          this.$store.dispatch('cartModule/clearCount');
          this.$store.dispatch('cartModule/clearMzItems');
          update = Object.keys(this.cart.items).map(e => {
            return new Promise((resolve, reject) => {
              axios.get(`/api/donor/${e}/${this.cart.items[e].material_type}/data`)
              .then((response) => {
                this.cart.items[e] = {
                  ...this.cart.items[e],
                  checked: this.cart.items[e].is_available,
                  name: this.productName(response.data._source.material),
                  age: response.data.fields?.age[0],
                  unit_price: this.prices[this.cart.items[e].material_type].price_brutto,
                  ...response.data
                }
                resolve(response);
              })
              .catch(error => {
                console.error(error);
                reject(error);
              })
            })
          });

          Promise.all(update)
          .then((response) => {
            this.$emit('price-change', {
              value: this.getCartValue(),
              cart_size: this.getCartSize(),
              discount_items: this.getCartSelectedDiscountItems()
            });
            this.$store.dispatch('cartModule/setCount', Object.keys(this.cart.items).length);
            this.$store.dispatch('cartModule/setMzItems', this.cart.items);
            resolve(response);
          })
          .catch(error => {
            console.error(error);
            reject(error);
          })
          .finally(() => {
            this.loading = false;
          })

        })
        .catch(error => {
          console.error(error);
          reject(error);
        })
      });
    },
    deleteElement(key) {
      return new Promise((resolve, reject) => {
        this.loading = true;
        axios.delete(`/api/cart?product_key=${key}`)
        .then((response) => {
          this.getCart();
          this.$gtag.event('donor', {
            'donor_product_key': key,
            'donor_event_value': 'remove from cart'
          })
          resolve(response);
        })
        .catch(error => {
          console.error(error);
          this.loading = false;
          reject(error);
        })
      });
    },
    addItem(item) {
      this.cart.items[item].quantity++;
      let materialType = this.cart.items[item].material_type;
      axios
        .post(`/api/cart`, {
          items: {
            [item]: {
              "material_type": materialType,
              "material_location_name": this.cart.items[item].material_location_name,
              "material_location_id": this.cart.items[item].material_location_id,
              "quantity": this.cart.items[item].quantity,
              "price": this.cart.items[item].unit_price,
              "price_id": this.prices[materialType].item_id,
              "price_name": this.prices[materialType].price_name,
              "age": this.cart.items[item].age,
              "mz_grant_file_id": this.cart.items[item].mz_grant_file_id,
              "want_mz_grant": this.cart.items[item].want_mz_grant,
              ...(materialType == 'mtSemen' && {procedure: this.cart.items[item]._source.material.fitness_for_insemination})
            }
          }
        })
    },
    removeItem(item) {
      this.cart.items[item].quantity--;
      let materialType = this.cart.items[item].material_type;
      axios
        .post(`/api/cart`, {
          items: {
            [item]: {
              "material_type": materialType,
              "material_location_name": this.cart.items[item].material_location_name,
              "material_location_id": this.cart.items[item].material_location_id,
              "quantity": this.cart.items[item].quantity,
              "price": this.cart.items[item].unit_price,
              "price_id": this.prices[materialType].item_id,
              "price_name": this.prices[materialType].price_name,
              "age": this.cart.items[item].age,
              "mz_grant_file_id": this.cart.items[item].mz_grant_file_id,
              "want_mz_grant": this.cart.items[item].want_mz_grant,
              ...(materialType == 'mtSemen' && {procedure: this.cart.items[item]._source.material.fitness_for_insemination})
            }
          }
        })
    },
    getCartSelectedDiscountItems() {
      let discountItems = [];
      if(this.cart.items) {
        Object.keys(this.cart.items).forEach(e => {
          if(this.cart.items[e].checked && this.cart.items[e].mz_grant_file_id) {
            discountItems.push(this.cart.items[e])
          }
        })
      }
      return discountItems;
    },
    getCartValue() {
      let full_price = 0;
      if(this.cart.items) {
        Object.keys(this.cart.items).forEach(e => {
          if(this.cart.items[e].checked) {
            full_price += this.cart.items[e].unit_price * this.cart.items[e].quantity;
          }
        })
      }
      return full_price;
    },
    getCartSize() {
      let cart_size = 0;
      if(this.cart.items) {
        Object.keys(this.cart.items).forEach(e => {
          if(this.cart.items[e].checked) {
            cart_size+= this.cart.items[e].quantity;
          }
        })
      }
      return cart_size;
    }
  }
}
</script>

<style lang="scss" scoped>
.input-label {
  font-size: 14px;
}
.value {
  min-width: 200px;
}
.cart-component {
  @include nsb-font-container;
  background: white;
  position: relative;
  .row {
    cursor: pointer;
    &:hover {
      background: transparent;
      cursor: default;
    }
  }
  .first_row {
    cursor: pointer;
    &:hover {
      background: transparent;
      cursor: default;
    }
  }
  .disabled {
    color: $ds-primary-3;
    &:hover {
      background: transparent;
      cursor: default;
    }
  }
  .v-input.set-quantity {
    // background-color: $nsb-background;
    width: 144px;
    height: 40px;
    border-radius: 4px;
    border: 1px solid $nsb-color-3;
    --v-input-control-height: 40px;
    --v-input-padding-top: 0px;
    :deep(.v-field__input) {
      color: $ds-primary; 
      font-size: 14px !important;
      line-height: 21px;
      // width: 48px;
      text-align: center;

      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
      }
      &[type=number] {
        -moz-appearance: textfield;
      }
    }
    .v-btn {
      opacity: 1;
      &.v-btn--disabled {
        opacity: 0.1;
      }
    }
  }
  .progress {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
  .reservation {
    &_header {
      @include nsb-gentium-bold;
      font-size: 23px;
      line-height: 26px;
    }
    &_id {
      .id {
        @include nsb-font-header;
        font-size: 14px;
        line-height: 21px;
      }
      .data {
        @include nsb-font-header;
        display: inline-block;
        font-size: 14px;
        line-height: 21px;
        padding: 0px 12px;
        border-radius: 12px;
        

        background: $ds-primary-9;
      }
    }
    &_data {
      &_label {
        @include nsb-font-header;
        font-size: 14px;
        line-height: 21px;
        color: $ds-primary-3;
      }
      &_unit_price {
        @include nsb-font-container;
        font-size: 14px;
        line-height: 21px;
        color: $ds-primary;
      }
      &_price {
        @include nsb-font-container;
        font-size: 12px;
        line-height: 18px;
        color: $ds-primary-3;
      }
    }
  }
  .no-refund {
    line-height: normal;
    color: $ds-primary-100;
    font-size: 12px !important;
    text-decoration: line-through;
  }
  .price-with-refund {
    line-height: normal;
    color: $ds-primary;
    font-size: 16px !important;
  }
  .mz-package-label {
    @include nsb-font-container;
    line-height: normal;
    border-radius: 100px;
    background: #F0FFF3;
    color: #0DA531;
    width: max-content;
    &.f-right {
      float: right;
    }
  }
}
/* The container */
.container {
  display: block;
  position: relative;
  padding-left: 32px;
  cursor: pointer;
  user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  box-sizing: border-box;
  border: 1px solid #869AB7;
  position: absolute;
  top: 0;
  left: 0;
  height: 16px;
  width: 16px;
  background-color: white;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: $nsb-disabled;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: $ds-primary;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 5px;
  top: 2px;
  width: 4px;
  height: 9px;
  border: solid white;
  border-width: 0 1px 1px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>